import {makeAutoObservable} from "mobx";
import {WithDisposers} from "@services/WithDisposers";
import {socket} from "@services/socket/socketInstanse";

export class WithSocketEvents {

    private disposers = new WithDisposers();


    constructor() {
        makeAutoObservable(this)
    }

    joinRoom = (room: string) => {
        socket.emit("joinRoom", room);
        this.disposers.subscribe(() => socket.emit("leaveRoom", room))
    }

    subscribe(events: Array<{ name: string; handler: (...args: any[]) => void }>) {
        events.forEach(event => {
            socket.on(event.name, event.handler);
        });

        this.disposers.subscribe(() => {
                events.forEach(event => {
                    socket.off(event.name);
                });
            }
        )
    }

    unsubscribe() {
        this.disposers.unsubscribe();
    }
}